module.exports = __webpack_public_path__ + "img/xqfw1.20dc671b.png";